export default __webpack_public_path__ + "locales/ar-SA/EmptyView.json?hash=caeda3ddd976e24e34e923fd134c69da";